import Image from "next/image";
import React from "react";

export default function EventImage({ data }) {
  return (
    <figure className="w-full  bg-white rounded-md">
      <Image
        src={
          (data && data[0])
            ? process.env.NEXT_PUBLIC_SPACES_URL + data[0]?.image
            : "https://e-commerce-test.sgp1.digitaloceanspaces.com/conferenceAndMembership/1716714683714-picture.png"
        }
        alt="nurse"
        height={1200}
        width={1200}
        className="h-full w-full object-cover"
      />
    </figure>
  );
}
